// extracted by mini-css-extract-plugin
export default {"message":"NotFoundPage_message__ZztKy","text":"NotFoundPage_text__3dOc0"};